export default __webpack_public_path__ + "static/media/logo-onboard-bdos-01.92fc2349.png";